import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type UserType = {
  id: number;
  email: string;
  role_id: number;
  stores: [];
  created_at: string;
  updated_at: string;
  is_active?: boolean | string;
};

export type UsersResponseType = UserType[];

export const useGetUsers = (
  options: QueryOptions<UsersResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<UsersResponseType> => {
      const { data } =
        await api.get<ApiResponse<UsersResponseType>>(`/user/list`);

      return data.data;
    },
    queryKey: ['users'],
    ...options,
  });
